import { Box, Table, TableBody, TableCell, TableHead, TableRow, Typography, useTheme } from "@mui/material";
import { useAppContext } from "context/Context";
import { prepareBreakdownValuesWithPercent } from "utils/summary";

// Child Summary Breakdown component that displays the breakdown data. If breakdown values don't have labels, assumes the keys are platforms
export default function ChildSummaryPlatformBreakdown({ title, breakdownValues, platformBreakdownExclusion = [], breakdownType }) {
  breakdownType = breakdownType || "Platform";
  const theme = useTheme();
  const {
    state: { selectedPlatforms },
  } = useAppContext();
  const breakdownValuesRows = prepareBreakdownValuesWithPercent(selectedPlatforms, breakdownValues, platformBreakdownExclusion);

  const midpoint = Math.ceil(breakdownValuesRows.length / 2);
  const breakdownValuesTableData = breakdownValuesRows.length >= 10 ? [
    breakdownValuesRows.slice(0, midpoint),
    breakdownValuesRows.slice(midpoint),
  ] : [breakdownValuesRows]

  const subTables = breakdownValuesTableData.map((breakdownValues, i) => (<Table data-testid="child-summary-platform-breakdown-table" key={i}>
        <TableHead sx={{ paddingBottom: theme.spacing("4px") }}>
            <TableRow>
                <TableCell sx={{ textAlign: "left", paddingTop: "0px", paddingBottom: "8px", paddingLeft: "0px", color: theme.palette.text.muted }} data-testid="child-summary-platform-breakdown-platform-header">{breakdownType}</TableCell>
                <TableCell sx={{ textAlign: "left", paddingLeft: "0px", paddingTop: "0px", paddingBottom: "8px", color: theme.palette.text.muted }} data-testid="child-summary-platform-breakdown-total-header">Total</TableCell>
                <TableCell sx={{ textAlign: "right", paddingTop: "0px", paddingBottom: "8px", color: theme.palette.text.muted }} data-testid="child-summary-platform-breakdown-percent-header">%</TableCell>
            </TableRow>
        </TableHead>
        <TableBody sx={{ paddingTop: theme.spacing("8px") }}>
            {breakdownValues.map(({label, value, percent}, i) => (
                <TableRow sx={{ borderBottom: `0px` }} key={i}>
                    <TableCell sx={{ textAlign: "left", paddingTop: "8px", paddingBottom: "0px", paddingLeft: "0px", color: theme.palette.text.muted, borderBottom: `0px`, whiteSpace: "nowrap" }} data-testid="child-summary-platform-breakdown-platform-value">{label}</TableCell>
                    <TableCell sx={{ textAlign: "left", paddingTop: "8px", paddingBottom: "0px", paddingLeft: "0px", color: theme.palette.text.primary, borderBottom: `0px` }} data-testid="child-summary-platform-breakdown-total-value">{value ? value.toLocaleString() : "-"}</TableCell>
                    <TableCell sx={{ textAlign: "right", paddingTop: "8px", paddingBottom: "0px", paddingLeft: "0px", color: theme.palette.text.muted, borderBottom: `0px` }} data-testid="child-summary-platform-breakdown-percent-value">{percent !== null ? `${percent}%` : "-"}</TableCell>
                </TableRow>
            ))}
        </TableBody>
    </Table>))

  const breakdownContents = subTables.length > 1 ? (
    <TableRow>
      {subTables.map((subTable, i) => (
        <TableCell sx={{ 
          paddingLeft: i === 0 ? "0px" : undefined, 
          paddingRight: i === subTables.length - 1 ? "0px" : undefined,
          paddingTop: "0px",
          paddingBottom: "0px",
          borderBottom: `0px` 
          }} key={i}>
            {subTable}
        </TableCell>))}
      </TableRow>
  ) : subTables[0]

  return (
    <Box sx={{ position: "absolute", backgroundColor: theme.palette.background.$1, padding: theme.spacing("16px"), borderRadius: "8px", border: `${theme.palette.border.widget}`, zIndex: 1000 }} >
      <Typography sx={{ textAlign: "center", paddingBottom: "16px", fontSize: "12px", fontWeight: "700", color: theme.palette.text.primary }} data-testid="child-summary-platform-breakdown-title">
        {title} breakdown
      </Typography>
      <Box>

      {breakdownContents}
      </Box>
    </Box>
  );
}
